// extracted by mini-css-extract-plugin
export var addButton = "_nr-0";
export var border = "_nr-8";
export var check = "_nr-h";
export var danger = "_nr-6";
export var dropdownContainer = "_nr-1";
export var editModalBody = "_nr-j";
export var footerContainer = "_nr-i";
export var fullWidth = "_nr-a";
export var hide = "_nr-9";
export var icon = "_nr-3";
export var input = "_nr-7";
export var inputFlex = "_nr-b";
export var inputWrapper = "_nr-c";
export var manualFocus = "_nr-5";
export var optionButton = "_nr-4";
export var pillWrapper = "_nr-e";
export var pointer = "_nr-2";
export var showOverflow = "_nr-f";
export var tagsFlex = "_nr-d";
export var xButton = "_nr-g";